import React from "react";
import DefaultSelect from "./DefaultSelect";
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const OptionSelect = ({ optionType, options, setFilter }) => {
  const { t } = useTranslation();
  const sortedOptions = [...options].sort((a, b) => {
    const numA = Number(a.label);
    const numB = Number(b.label);

    if (isNaN(numA) && isNaN(numB)) {
      return a.label?.localeCompare(b.label);
    } else if (isNaN(numA)) {
      return 1;
    } else if (isNaN(numB)) {
      return -1;
    } else {
      return numA - numB;
    }
  });

  const defaultProps = {
    options: sortedOptions,
    getOptionLabel: (option) => option.label,
  };

  if (optionType === "default") {
    return (
      <Autocomplete
        {...defaultProps}
        id="auto-complete"
        noOptionsText={t("No options")}
        autoComplete
        size="small"
        closeText={t("Close")}
        includeInputInList
        onChange={(event, newValue) => {
          setFilter(newValue?.label);
        }}
        renderInput={(params) => (

          <TextField  sx={{ color: '#B9B9B9', minWidth: 120, width: '100%' }} {...params} variant="outlined" placeholder={t("Select")}/>
        )}

       
      />
    );
  } else if (optionType === "multiple") {
    return <DefaultSelect setFilter={setFilter} options={sortedOptions} variant="outlined" />;
  }

  return <div>OptionSelect</div>;
};

export default OptionSelect;
